//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["stock_data","anchor","cross_section","segments","num_stocks"],"CreateStock",{R_:{stocks:"Routing.Stock[]"}},4,0],[["component"],"GetComponentStock",{R_:{stock:"Routing.Stock"}},1,0],[["convertSpaceReservartion","nameType"],"ConvertToStockAsComponents",{},2,0],[["stock_part","data_charx","segments","route_level"],"AddStock",{},4,0],[["stock_part","data_charx","segments","route_level","num_stocks","stocks"],"AddStock1",{},4,0],[["stock_part","data_charx","segments","route_level","is_space_reservation","num_stocks","stocks"],"AddStock2",{},5,0],[["stock_part","data_charx","segments","route_level","is_space_reservation","anchor_name","num_stocks","stocks"],"AddStock3",{},6,0],[["segments"],"RemoveStock",{},1,0],[["segments"],"RemoveAllFillerStocks",{},1,0],[["segments"],"UpdateBundleStockForFiller",{},1,0],[["part_occ"],"SetAttachedStockLength",{},1,0],[["object"],"SetReferenceStockFromObject",{},1,0],[[],"ResetReferenceStock",{},0,0],[["object"],"GetStockFromObject",{R_:{stock:"Routing.Stock"}},1,0]],[]];
SPLM.Routing.StockCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.StockCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;